module.exports = __webpack_public_path__ + "img/pepe-sad.daf006d0.jpg";